import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthApis } from "../../../apis/authApis";
import { useDispatch } from "react-redux";
import { login } from "../../reducer/loginSlice";
import { useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner'
import { useSelector } from "react-redux";

function EmailVerify() {

  const params: any = useParams();
  let email: string = params?.email;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = React.useState(false);
  const userLoginData = useSelector((state: any) => state.data.login.value);

  React.useEffect(() => {
    if (userLoginData?.data?.user_data?.status) {
      navigate('/sign-in');
    }

    AuthApis.verifyMail(email).then(
      (response) => {
        if (response?.data) {
          if (response?.data?.status === true) {
            navigate('/sign-in');
          }
        }
      }
    ).catch(function (error) {
      navigate('/email-verify');
      console.log(error.response.data);
    })
  }, [email]);

  return (
    <>

      <div className="flex justify-center mt-[50vh]">
        <Oval
          visible={true}
          height="80"
          width="80"
          color="#0071DC"
          secondaryColor="#E6F1FC"
          ariaLabel="oval-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    </>
  );
}

export default EmailVerify;
